// Données fictives pour Baya Couture
export const mockData = {
  hero: {
    title: "Baya Couture",
    subtitle: "Spécialiste de retouches de vêtements et rideaux à Antony",
    description: "Expertise artisanale pour sublimer vos vêtements et transformer vos rideaux. Service professionnel et personnalisé depuis plus de 10 ans.",
    cta: "Nous contacter"
  },
  
  services: [
    {
      id: 1,
      title: "Retouches de Vêtements",
      description: "Ajustements, réparations, et modifications sur tous types de vêtements",
      features: [
        "Ourlets pantalons, jupes, robes",
        "Ajustement à la taille",
        "Réparation de fermetures éclair",
        "Reprise des manches",
        "Rétrécissement et élargissement"
      ],
      price: "À partir de 15€",
      image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80"
    },
    {
      id: 2,
      title: "Retouches de Rideaux",
      description: "Création et ajustement de rideaux sur mesure pour tous vos espaces",
      features: [
        "Ourlets de rideaux",
        "Pose d'œillets et anneaux",
        "Confection sur mesure",
        "Réparation de doublures",
        "Ajustement de longueur"
      ],
      price: "À partir de 25€",
      image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80"
    }
  ],
  
  about: {
    title: "Notre Expertise",
    description: "Chez Baya Couture, nous mettons notre savoir-faire artisanal au service de vos besoins. Avec plus de 10 années d'expérience, nous garantissons un travail soigné et des finitions impeccables.",
    features: [
      "Plus de 10 ans d'expérience",
      "Travail artisanal de qualité",
      "Consultation gratuite et sans engagement",
      "Service rapide et fiable"
    ]
  },
  
  contact: {
    address: "1 bis rue Pernoud, 92160 Antony",
    phone: "01 49 10 03 88",
    email: "bayacouture@outlook.com",
    hours: {
      weekdays: "Mardi - Mercredi - Vendredi - Samedi: 10h00 - 13h00 et 14h00 - 18h00",
      weekend: "Fermé dimanche, lundi et jeudi"
    }
  },
  
  testimonials: [
    {
      id: 1,
      name: "Marie Dupont",
      location: "Centre-ville, Antony",
      rating: 5,
      text: "Service impeccable ! Mes rideaux sont parfaitement ajustés et la qualité du travail est remarquable."
    },
    {
      id: 2,
      name: "Pierre Martin",
      location: "La Croix de Berny, Antony",
      rating: 5,
      text: "Très satisfait des retouches de mes costumes. Travail soigné et délais respectés."
    },
    {
      id: 3,
      name: "Sophie Leroy",
      location: "Fontaine Michalon, Antony",
      rating: 5,
      text: "Je recommande vivement ! Excellent rapport qualité-prix et accueil chaleureux."
    }
  ]
};